import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './LandingSection.scss';

interface LandingSectionProps {
  title: string;
  children: React.ReactNode;
  onHeaderClick?: () => void;
  className?: string;
}

const LandingSection: React.FC<LandingSectionProps> = ({
  title,
  children,
  onHeaderClick,
  className,
}) => {
  const { t } = useTranslation('landing');

  const handleHeaderClick = () => {
    if (onHeaderClick) {
      onHeaderClick();
    }
  };

  return (
    <div className={`landing-section ${className || ''}`}>
      <div className="landing-section-header">
        <div className="landing-section-title">{title}</div>
        <Button type="link" onClick={handleHeaderClick}>
          {t('viewAll')}
        </Button>
      </div>
      <div className="landing-horizontal-scroll">{children}</div>
    </div>
  );
};

export default LandingSection;
